/* src/app/component/promotion-dashboard/promotion-dashboard-tabs/promotion-dashboard-tabs.component.scss */
.no-results {
  margin-left: 500px;
  padding: 32px 0;
  color: #555;
  font-size: 16px;
}
.no-results-text strong {
  color: #D47500;
}
::ng-deep .link {
  display: inline-block;
  color: #ce8225;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  position: relative;
  padding-left: 1px;
  transition: all 0.3s ease;
}
.preview-link:hover {
  color: #A55600;
}
.preview-link:hover::after {
  width: 100%;
  background-color: #A55600;
}
::ng-deep .p-datatable.p-datatable-sm .p-datatable-thead > tr > th {
  padding: 12px;
  color: #475467;
  font-size: 14px;
}
::ng-deep .p-datatable.p-datatable-sm .p-datatable-tfoot > tr > td {
  padding: 12px 20px !important;
  background-color: white;
}
::ng-deep .p-datatable .p-datatable-tfoot > tr > td {
  border: none;
  border-radius: 8px;
  background-color: #fff;
}
:host ::ng-deep .p-datatable .p-datatable-wrapper {
  overflow: hidden !important;
}
.scroll-table-wrapper {
  margin-top: 20px;
}
.paginator-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.paginator-left {
  display: flex;
}
.paginator-right {
  font-size: 14px;
}
.paginator-left button {
  margin-right: 5px;
}
::ng-deep .p-paginator .p-paginator-current {
  margin: 0;
}
::ng-deep .p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next {
  margin: 0 5px;
}
.pagination-button {
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background-color: white;
  color: #344054;
  cursor: pointer;
}
button.p-paginate:disabled {
  opacity: 0.6;
}
.pagination-button:hover:not(:disabled) {
  background-color: #f4f5f7;
}
::ng-deep .p-datatable {
  border: 1px solid #d1d5db;
  border-radius: 8px;
}
::ng-deep th {
  border-radius: 8px 8px 0px 0px;
  padding: 12px 24px;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  color: #475467;
}
::ng-deep td {
  padding: 16px 24px;
  font-size: 14px;
  color: #475467;
}
.status-stamp {
  padding: 6px 12px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-block;
}
.approved-stamp {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background-color: #ECFDF3;
  color: #027A48;
}
.approved-stamp::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #4caf50;
}
.rejected-stamp {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  background-color: #FFEAEB;
  color: #FF474D;
}
.rejected-stamp::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #FF474D;
}
::ng-deep .p-button {
  padding: 12px 12px;
}
:host ::ng-deep .p-button-label {
  color: #D47500 !important;
}
.danger {
  color: #ffffff;
  background: #ef4444;
  border: 1px solid #ef4444;
}
.btn {
  height: 30px !important;
  font-size: 14px;
}
.empty-state-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
}
.empty-state {
  text-align: center;
  padding: 40px;
}
.empty-state .span1 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #FFF1E0;
  color: #FF8C00;
  display: inline-block;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-weight: 500;
  margin-right: 10px;
}
.promotion-name {
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
/*# sourceMappingURL=promotion-dashboard-tabs.component-AUUS6QJJ.css.map */
